/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TaskAction {
    RESTART = 'restart'
}

export function TaskActionFromJSON(json: any): TaskAction {
    return TaskActionFromJSONTyped(json, false);
}

export function TaskActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskAction {
    return json as TaskAction;
}

export function TaskActionToJSON(value?: TaskAction | null): any {
    return value as any;
}

